import { faBuildings } from '@fortawesome/pro-solid-svg-icons/faBuildings';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import type { LinkOutContent, LinkOutRoute } from './types';

export const USERS_CONTENT: LinkOutContent = {
  title: 'Users',
  heading: 'Manage users in the new App',
  message: 'Users have moved to the new Appcues App.',
  icon: faUsers,
};

export const USER_PROFILE_CONTENT: LinkOutContent = {
  title: 'User profile',
  heading: 'View user profiles in the new App',
  message: 'User profiles have moved to the new Appcues App.',
  icon: faUsers,
};

export const ACCOUNTS_CONTENT: LinkOutContent = {
  title: 'Accounts',
  heading: 'Manage accounts in the new App',
  message: 'Accounts have moved to the new Appcues App.',
  icon: faBuildings,
};

export const ACCOUNT_CONTENT: LinkOutContent = {
  title: 'Account',
  heading: 'View accounts in the new App',
  message: 'Account pages have moved to the new Appcues App.',
  icon: faBuildings,
};

const USER_TAB_QUERIES: Record<string, string> = {
  properties: '',
  activities: '?utab=activity',
  segments: '?utab=segments',
  eligibility: '?utab=eligibility',
};

// Bare `/audience/users` and `/audience/users/:id` are left alone: classic
// redirects them to `users-v2` and `properties`, which link out.
const routes: LinkOutRoute[] = [
  {
    pattern: /^\/audience\/users-v2\/?$/i,
    resolve: () => '/audiences/users',
    content: USERS_CONTENT,
    examples: ['/audience/users-v2'],
  },
  {
    pattern:
      /^\/audience\/users\/([^/]+)\/(properties|activities|segments|eligibility)\/?$/i,
    resolve: ([, id, tab]) =>
      `/audiences/users/${id}${USER_TAB_QUERIES[tab.toLowerCase()]}`,
    content: USER_PROFILE_CONTENT,
    examples: [
      '/audience/users/abc/properties',
      '/audience/users/abc/activities',
      '/audience/users/abc/segments',
      '/audience/users/abc/eligibility',
    ],
  },
  {
    pattern: /^\/audience\/accounts\/?$/i,
    resolve: () => '/audiences/accounts',
    content: ACCOUNTS_CONTENT,
    examples: ['/audience/accounts'],
  },
  {
    pattern:
      /^\/audience\/accounts\/([^/]+)\/(overview|usage|properties|users)\/?$/i,
    resolve: ([, id, tab]) =>
      `/audiences/accounts/${id}${tab.toLowerCase() === 'users' ? '?gtab=users' : ''}`,
    content: ACCOUNT_CONTENT,
    examples: [
      '/audience/accounts/g-1/overview',
      '/audience/accounts/g-1/usage',
      '/audience/accounts/g-1/properties',
      '/audience/accounts/g-1/users',
    ],
  },
];

export default routes;
